/**
 * Route incoming deep links (Universal Links / a registered custom URL
 * scheme) to the screen they point at. No-ops on web. See
 * deep-link-routing.ts for the pure URL→route mapping this consumes.
 *
 * NOTE (#960): this listener is the app-side half of the fix only. Tapping
 * "View Schedule" in a notification email still opens the browser until a
 * human also does the native registration this depends on — an Associated
 * Domains entitlement + apple-app-site-association hosting on iOS, and an
 * autoVerify App Links intent-filter + assetlinks.json on Android. Neither
 * is wired up yet in this repo (ios/, android/, capacitor.config.ts are
 * off-limits to automated changes per CLAUDE.md). Once that's done, this
 * listener starts firing for links tapped outside the app.
 */
import { App, type URLOpenListenerEvent } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { resolveDeepLinkTarget } from '@/lib/deep-link-routing';

export function listenForDeepLinks(onNavigate: (path: string) => void): () => void {
  if (!Capacitor.isNativePlatform()) return () => {};

  let remove: (() => void) | undefined;
  App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
    const target = resolveDeepLinkTarget(event.url);
    if (target) onNavigate(target);
  }).then((handle) => {
    remove = () => handle.remove();
  });

  return () => remove?.();
}
